import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import LinearProgress from "@material-ui/core/LinearProgress";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  button: {
    margin: "5px",
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const NewCarrier = () => {
  const classes = useStyles();
  const history = useNavigate();

  const [loading, setLoading] = useState(false);
  const [successFetch, setSuccessFetch] = useState(false);

  const [nameInput, setNameInput] = useState("");
  const [contactNameInput, setContactNameInput] = useState("");
  const [contactEmailInput, setContactEmailInput] = useState("");
  const [contactPhoneInput, setContactPhoneInput] = useState("");

  const submitHandler = (e) => {
    e.preventDefault();

    let formData = {
      name: nameInput,
      contactName: contactNameInput,
      contactEmail: contactEmailInput,
      contactPhone: contactPhoneInput,
    };

    var stringArray = [];
    var errorMesssage = "Validation Error - ";
    if (formData.name == "") stringArray.push("Name");
    if (formData.contactName == "") stringArray.push("Contact Name");
    if (formData.contactEmail == "") stringArray.push("Contact Email");
    if (formData.contactPhone == "") stringArray.push("Contact Phone");

    if (
      formData.name == "" ||
      formData.contactName == "" ||
      formData.contactEmail == "" ||
      formData.contactPhone == ""
    ) {
      stringArray.map((error, index) => {
        if (index === stringArray.length - 1)
          errorMesssage += index == 0 ? error : " & " + error;
        else errorMesssage += index == 0 ? error : ", " + error;
      });
      sendAlert((errorMesssage += " Required"), "warning");
      return;
    }

    let success = false;
    setLoading(true);

    fetchWithToken(`api/Carriers/`, "POST", formData)
      .then((res) => {
        console.log("res", res);
        if (res.ok) {
          success = true;
          setSuccessFetch(true);
        }
        return res.json();
      })
      .then((data) => {
        setSuccessFetch(false);
        sendAlert(data.returnMessage, success ? "success" : "error");
        setLoading(false);
      });
  };

  useEffect(() => {
    if (successFetch) clearPoolForm();
  }, [successFetch]);

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const clearPoolForm = () => {
    setNameInput("");
    setContactNameInput("");
    setContactEmailInput("");
    setContactPhoneInput("");
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <CardContent>
              <form onSubmit={submitHandler}>
                <div class="mb-3 row">
                  <div class="col-sm-12">
                    <input
                      type="text"
                      name="name"
                      value={nameInput}
                      maxlength="30"
                      placeholder="Name *"
                      class="form-control"
                      onChange={(e) => {
                        clearAlert();
                        setNameInput(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-12">
                    <input
                      type="text"
                      name="contactName"
                      value={contactNameInput}
                      maxlength="30"
                      placeholder="Contact Name *"
                      class="form-control"
                      onChange={(e) => {
                        clearAlert();
                        setContactNameInput(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-12">
                    <input
                      type="text"
                      class="form-control"
                      value={contactEmailInput}
                      name="contactEmail"
                      placeholder="Contact Email *"
                      maxlength="50"
                      onChange={(e) => {
                        clearAlert();
                        setContactEmailInput(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div class="mb-3 row">
                  <div class="col-sm-12">
                    <input
                      type="text"
                      class="form-control"
                      value={contactPhoneInput}
                      name="contactPhone"
                      placeholder="Contact Phone *"
                      maxlength="30"
                      onChange={(e) => {
                        clearAlert();
                        setContactPhoneInput(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {loading && (
                  <>
                    <div style={{ margin: "25px" }}>
                      <span style={{ display: "table", margin: "0 auto" }}>
                        Please Wait For Process to Finish
                      </span>
                      <LinearProgress />
                    </div>
                  </>
                )}
                <Button
                  type="submit"
                  variant="contained"
                  className={classes.button}
                  color="primary"
                >
                  Submit
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default NewCarrier;
